import React from 'react';
import type { TooltipRenderProps } from 'react-joyride';
import { useLanguage } from '../contexts/LanguageContext';

const TourTooltip: React.FC<TooltipRenderProps> = ({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}) => {
  const { t } = useLanguage();
  const finish = Boolean((step as { data?: { isFinish?: boolean } }).data?.isFinish);

  return (
    <div
      {...tooltipProps}
      className="w-[min(360px,calc(100vw-32px))] rounded-xl border border-gray-100 bg-white p-4 shadow-lg"
    >
      {step.title && (
        <h3 className="text-sm font-semibold text-gray-900 mb-1.5">{step.title}</h3>
      )}
      <div className="text-sm text-gray-600 leading-relaxed mb-4">{step.content}</div>
      <div className="flex items-center justify-between gap-2">
        <button
          type="button"
          {...skipProps}
          className="text-xs font-medium text-gray-500 hover:text-gray-700 px-2 py-1.5"
        >
          {t('tour.skip')}
        </button>
        <div className="flex items-center gap-2">
          <span className="text-[11px] text-gray-400 tabular-nums">
            {index + 1}/{size}
          </span>
          {index > 0 && (
            <button
              type="button"
              {...backProps}
              className="px-3 py-1.5 rounded-xl border border-gray-200 text-xs font-semibold text-gray-600 hover:bg-gray-50"
            >
              {t('tour.back')}
            </button>
          )}
          {continuous && (
            <button
              type="button"
              {...primaryProps}
              className="px-3 py-1.5 rounded-xl bg-primary-600 text-white text-xs font-semibold hover:bg-primary-700"
            >
              {finish || isLastStep ? t('tour.finish.cta') : t('tour.next')}
            </button>
          )}
          {!continuous && (
            <button
              type="button"
              {...closeProps}
              className="px-3 py-1.5 rounded-xl bg-primary-600 text-white text-xs font-semibold hover:bg-primary-700"
            >
              {t('tour.finish.cta')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;
